import { getSVG } from './components/icons-loader.js';
import { displayCookieBanner } from './components/cookies-banner.js';
import { videoLazyLoading } from './components/video.js';

document.addEventListener("DOMContentLoaded", function () {
  getSVG();
  displayCookieBanner();
  videoLazyLoading();
});
